import ClientActionTypes from './client.types';

const INITIAL_STATE = {
  clients: []
};

const clientReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ClientActionTypes.SET_CLIENTS:
      return {
        ...state,
        clients: action.payload
      };
    default:
      return state;
  }
};

export default clientReducer;
